__turbopack_context__.v({
  "details": "c94PmG_details",
  "hideLabel": "c94PmG_hideLabel",
  "icon": "c94PmG_icon",
  "isInactive": "c94PmG_isInactive",
  "priceLabel": "c94PmG_priceLabel",
  "priceList": "c94PmG_priceList",
  "priceRow": "c94PmG_priceRow",
  "priceValue": "c94PmG_priceValue",
  "showLabel": "c94PmG_showLabel",
  "toggle": "c94PmG_toggle",
});
